import * as React from "react";
import TextInput from "./TextInput";
import {InputFieldState} from "./InputFieldState";

interface PasswordInputProps {
  label: string;
  state: InputFieldState;
  onChange?: (value: string, event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (value: string, event: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  editable?: boolean;
  onEnterPressed?: () => void;
  className?: string;
  focus?: boolean;
  disabled?: boolean;
  autocomplete?: string;
  children?: React.ReactNode;
}

const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  return (
    <TextInput
      {...props}
      type="password"
      autocomplete="current-password"
    />
  );
};

export default PasswordInput;